import React from 'react';
import './Legal.css';
import { useNavigate, Link } from 'react-router-dom';

const PrivacyPolicy = () => (
  <div className="legal-container">
    <h1 className="legal-title">Privacy Policy</h1>

    <section className="legal-section stripe-light">
      <h2>1. Introduction</h2>
      <p>
        OnlyStats (“we”, “us”, “our”) is committed to protecting your privacy.
        This Privacy Policy explains how we collect, use, and share your
        personal information.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>2. Information We Collect</h2>
      <p>
        <strong>Account Information:</strong> email, username, birthdate.<br/>
        <strong>Usage Data:</strong> pages viewed, interactions, IP address.<br/>
        <strong>Cookies &amp; Tracking:</strong> for preferences and analytics.
      </p>
    </section>

    <section className="legal-section stripe-light">
      <h2>3. How We Use Your Data</h2>
      <p>
        We use your information to provide and improve our services, send
        administrative messages, prevent fraud, and comply with legal
        obligations.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>4. Data Sharing &amp; Disclosure</h2>
      <p>
        We do not sell personal data. We may share with service providers for
        hosting, analytics, and email delivery under strict confidentiality
        agreements.
      </p>
    </section>

    <section className="legal-section stripe-light">
      <h2>5. Your Rights</h2>
      <p>
        You may access, correct, or delete your account data at any time
        via your dashboard settings. Contact us for any additional requests.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>6. Security</h2>
      <p>
        We implement industry-standard technical and organizational measures
        to protect your data from unauthorized access, alteration, or loss.
      </p>
    </section>

    <section className="legal-section stripe-light">
      <h2>7. Cookies</h2>
      <p>
        We use cookies to remember preferences and to collect analytics.
        You can disable cookies via your browser, but some features may not work.
      </p>
    </section>

    <section className="legal-section stripe-dark-2">
      <h2>8. Updates to This Policy</h2>
      <p>
        We may update this policy from time to time. Changes will be posted
        here with a revised effective date.
      </p>
    </section>

    <footer className="legal-footer">
      <p>© 2025 OnlyStats. All rights reserved.</p>
      {/* <p>
        Questions? <a href="/contact">Get in touch</a>.
      </p> */}
    </footer>
  </div>
);

export default PrivacyPolicy;
